import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaStar, FaQuoteLeft } from 'react-icons/fa';

const testimonials = [
  { name: 'Dr. Rajesh Kumar', role: 'Medical Director', company: 'HealthCare Plus', rating: 5, image: '👨⚕️', text: 'BottomFunnel completely transformed our digital presence. Patient inquiries skyrocketed by 200% within just 3 months. Their strategic approach and attention to detail is unmatched.' },
  { name: 'Priya Sharma', role: 'Celebrity Makeup Artist', company: 'Glam Studio', rating: 5, image: '💄', text: 'Working with BottomFunnel has been a game-changer. Their social media strategies helped me build an engaged following of 100K+ and my bookings are now consistently booked months in advance!' },
  { name: 'Amit Patel', role: 'Founder & Director', company: 'Dance Fusion Studio', rating: 5, image: '🎭', text: "Outstanding video production and marketing expertise! Our student enrollment doubled this year, and we've become the most sought-after dance academy in the region." },
  { name: 'Sarah Johnson', role: 'CEO', company: 'Tech Innovations Pvt Ltd', rating: 5, image: '🚀', text: 'Professional, data-driven, and results-oriented. BottomFunnel is hands down the best marketing partner we could ask for. Our revenue grew 300% in 6 months!' },
];

export default function Testimonials() {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const iv = setInterval(() => setIdx(p => (p + 1) % testimonials.length), 6000);
    return () => clearInterval(iv);
  }, []);

  const t = testimonials[idx];

  return (
    <section id="testimonials" className="py-32 px-4 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-cyan-500/5 to-transparent pointer-events-none" />
      <div className="max-w-6xl mx-auto relative z-10">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }} className="text-center mb-20">
          <motion.span whileHover={{ scale: 1.05 }}
            className="inline-block px-6 py-2 bg-gradient-to-r from-cyan-500/10 to-orange-500/10 border border-cyan-500/20 rounded-full text-sm font-semibold text-cyan-400 mb-6 backdrop-blur-sm">
            Testimonials
          </motion.span>
          <h2 className="text-5xl md:text-7xl font-black mb-8">
            Client <span className="bg-gradient-to-r from-cyan-400 to-orange-500 bg-clip-text text-transparent">Success Stories</span>
          </h2>
          <div className="flex items-center justify-center gap-3 mb-4">
            {[...Array(5)].map((_, i) => (
              <motion.div key={i} initial={{ opacity: 0, scale: 0 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: i * 0.1 }}>
                <FaStar className="text-4xl text-orange-500" />
              </motion.div>
            ))}
          </div>
          <p className="text-3xl font-bold bg-gradient-to-r from-orange-400 to-orange-600 bg-clip-text text-transparent">4.9/5 Average Rating</p>
          <p className="text-gray-500 mt-2">Based on 500+ reviews</p>
        </motion.div>

        <AnimatePresence mode="wait">
          <motion.div key={idx}
            initial={{ opacity: 0, x: 100, rotateY: 15 }} animate={{ opacity: 1, x: 0, rotateY: 0 }}
            exit={{ opacity: 0, x: -100, rotateY: -15 }} transition={{ duration: 0.5, type: 'spring' }}>
            <div className="bg-gradient-to-br from-gray-50/80 dark:from-gray-900/80 to-white/80 dark:to-black/80 p-12 md:p-16 rounded-3xl border border-gray-200 dark:border-gray-800 backdrop-blur-md relative overflow-hidden">
              <div className="absolute top-8 left-8 text-8xl text-cyan-500/10"><FaQuoteLeft /></div>
              <div className="flex items-center justify-center gap-2 mb-8 relative z-10">
                {[...Array(t.rating)].map((_, i) => (
                  <motion.div key={i} initial={{ opacity: 0, scale: 0 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: i * 0.1 }}>
                    <FaStar className="text-3xl text-orange-500" />
                  </motion.div>
                ))}
              </div>
              <p className="text-gray-700 dark:text-gray-300 text-2xl md:text-3xl mb-12 text-center italic leading-relaxed font-light relative z-10">
                "{t.text}"
              </p>
              <div className="flex flex-col md:flex-row items-center justify-center gap-6 relative z-10">
                <div className="text-6xl">{t.image}</div>
                <div className="text-center md:text-left">
                  <p className="text-gray-900 dark:text-white font-bold text-2xl mb-1">{t.name}</p>
                  <p className="text-cyan-400 text-lg font-semibold">{t.role}</p>
                  <p className="text-gray-500 text-sm">{t.company}</p>
                </div>
              </div>
            </div>
          </motion.div>
        </AnimatePresence>

        <div className="flex items-center justify-center gap-4 mt-12">
          {testimonials.map((_, i) => (
            <motion.button key={i} onClick={() => setIdx(i)} whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.9 }}
              className={`transition-all duration-300 ${i === idx ? 'w-12 h-3 bg-gradient-to-r from-cyan-400 to-orange-500 rounded-full' : 'w-3 h-3 bg-gray-600 hover:bg-gray-500 rounded-full'}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
